const getQueryParam = (param: string) => {
  return new URLSearchParams(window.location.search).get(param);
};

export default getQueryParam;
